export const HISTORY_CONVERSIONS = 'conversions';
export const HISTORY_DASHBOARDS = 'dashboards';
export const HISTORY_DETECTIONS = 'detections';
export const HISTORY_EXPORTS = 'exports';
export const HISTORY_FUNNELS = 'funnels';
export const HISTORY_HEATMAPS = 'heatmaps';
export const HISTORY_HIGHLIGHTS = 'highlights';
export const HISTORY_HIGHLIGHTS_DEFAULT = 'everyone';
export const HISTORY_HOME = 'home';
export const HISTORY_JOURNEYS = 'journeys';
export const HISTORY_METRICS = 'metrics';
export const HISTORY_ONBOARDING = 'onboarding';
export const HISTORY_SEARCHIE = 'searchie';
export const HISTORY_SEGMENTS = 'segments';
export const HISTORY_SESSION = 'session';
export const HISTORY_SESSION_EXPANDER = 'sessionExpander'; // Used to take a session link + search criteria and turn that into a clip.
export const HISTORY_SETTINGS = 'settings';
export const HISTORY_STORIES = 'stories';
export const HISTORY_TERMS_AND_CONDITIONS = 'termsandconditions';
